const _excluded = ["type", "entryFilter"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useState } from 'react';
import partition from 'lodash/partition';
import { clsx } from 'clsx';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { SectionItem } from 'common/components/items-menu/types';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { ChangeEvent } from 'common/components/select/types';
import { DEFAULT_FILTER_OPERATOR } from 'common/query-builder/cohorts-query-builder/models/constants';
import { QueryBlockReact } from 'common/query-builder/query-block';
import { EventItem } from 'common/query-builder/query-block/events-menu/types';
import { IncludeCustomPropertyType, isProperty, MenuItemType, SelectedPropertyItem, TypecastPillAction } from 'common/query-builder/query-block/properties-menu/types';
import { getCohortFromPropertyItem } from 'common/query-builder/query-block/utils/util';
import { getEntryFilters, populateListPropertyAttrs } from 'common/query-builder/query-entry-section/row-types/row-util';
import { Action, CohortGroupEntry, EntryPart, EntrySectionUpdates, FiltersOperator, FiltersOperatorDisplayLabels, isEventBasedEntry, QueryBehaviorEntry, QueryEntry, QueryFilterEntry, RowLabelType } from 'common/query-builder/query-entry-section/types';
import { PropertyType, ResourceType } from 'common/report/constants';
import { PRIMITIVE_MATH_TYPES } from 'common/types/reports/bookmark';
import { cohortsStore } from 'common/report/stores/cohorts';
import { getPropertyTypeForMathType } from 'common/report/util';
import { Behavior } from 'common/types/reports/query';
import { assert, replaceByIndex } from 'common/util';
import { isBehavioralCustomProperty } from 'common/widgets/custom-property-modal/util';
import { DEFAULT_FILTER_VALUE, PropertyFilter } from 'common/widgets/property-filter-menu/models/property-filter';
import { ListOperator, NumberOperator } from 'common/widgets/property-filter-menu/models/types';
// eslint-disable-next-line import/no-cycle
import { QueryEntrySectionReact } from 'common/query-builder/query-entry-section';
import { RowFilters, RowFiltersPrefix } from 'common/query-builder/query-entry-section/components/filters';
import { SUPPORTED_BEHAVIORAL_AGGREGATIONS } from 'common/report/util/cohorts/utils';
import { SelectorType } from 'common/query-builder/query-block/constants';
import { MenuType } from 'common/query-builder/query-block/types';
import { useTranslation } from 'common/i18n/hooks';
import { isAggregationUserFreqByGroupBehavior, isScdPropertyName } from 'common/report/util/properties';
import { BaseEntryRow } from '../base';
import { DEFAULT_EMPTY_BEHAVIORAL_ENTRY, isBehavioralFilterNegated, transformBehavioralFilterToBehavioralEntry } from '../behavior/utils';
import { applyFilterOperatorToFilter, getFilterEntriesFromFilters } from '../filter/utils';
import { EntryRowProps } from '../types';
import { BehavioralAction } from './types';
// eslint-disable-next-line import/no-cycle
import { helpers } from './helpers';

/** determines if any of the commited entries contain extended logical operators (`and any`, `or all`) */
function showExtendedLogicalOperators(entries: CohortGroupEntry[], operatorField: `filtersOperator` | `behavioralFiltersOperator`) {
  return entries.some(entry => entry[operatorField] === FiltersOperator.AndAny || entry[operatorField] === FiltersOperator.OrAll);
}
export function CohortGroupEntryRow(props: EntryRowProps<CohortGroupEntry>) {
  const [entryEl, setEntryEl] = useState<HTMLDivElement>(null);
  const {
    t,
    print
  } = useTranslation();
  const entryFilters = getEntryFilters(props.entry, props.sectionProps.behaviorMode);
  const getGroupTitle = () => {
    const cohort = props.entry.event;
    let title = t("query-builder.cohorts.all-dg", {
      dataGroupName: print(props.getSelectedGroupLabel(true))
    }) as string;
    if (Number.isInteger(cohort.value)) {
      var _cohortsStore$value;
      const label = ((_cohortsStore$value = cohortsStore.value[cohort.value as number]) === null || _cohortsStore$value === void 0 ? void 0 : _cohortsStore$value.name) || cohort.label;
      title = cohort.negated ? t("query-builder.cohorts.not-in-cohort", {
        cohortName: label
      }) as string : label;
    }
    return title;
  };
  const handleEntryGroupingOperatorClick = () => {
    const entry = _objectSpread(_objectSpread({}, props.entry), {}, {
      groupingOperator: props.entry.groupingOperator === FiltersOperator.Or ? FiltersOperator.And : FiltersOperator.Or
    }) as CohortGroupEntry;
    props.updateEntry(Action.Edit, entry);
  };

  /** handles property item select, either from the main `All Users` block or adding a new filter */
  const handlePropertyItemClick = (_ref: SelectedPropertyItem) => {
    let {
      menuItemType,
      item
    }: SelectedPropertyItem = _ref;
    assert(!Array.isArray(item));
    /**
     * we need to determine what type of entry point the user clicked on
     * for an event, we construct a behavioral frequency filter
     */
    if (menuItemType === MenuItemType.Events) {
      var _entryFilters$EntryPa;
      const event = item as EventItem;
      const behavioralEntry = _objectSpread(_objectSpread({}, DEFAULT_EMPTY_BEHAVIORAL_ENTRY), {}, {
        event
      });
      const entries = [...((_entryFilters$EntryPa = entryFilters[EntryPart.BehavioralFrequencyFilters]) !== null && _entryFilters$EntryPa !== void 0 ? _entryFilters$EntryPa : []).map(filter => transformBehavioralFilterToBehavioralEntry(filter)), behavioralEntry];
      handleFilterSectionUpdate(EntryPart.BehavioralFrequencyFilters, {
        entries,
        updatedEntry: null,
        updatedEntryIndex: null
      });
    } else if (menuItemType === MenuItemType.Cohorts) {
      // construct a default cohort filter
      const cohortFilter = new PropertyFilter({
        resourceType: ResourceType.Cohort,
        propertyType: PropertyType.List,
        filterOperator: ListOperator.Contains,
        filterValue: [getCohortFromPropertyItem(item)]
      });
      handleFilterSectionUpdate(EntryPart.Filters, {
        entries: getFilterEntriesFromFilters([...entryFilters[EntryPart.Filters], cohortFilter], props.entry.filtersOperator),
        updatedEntry: null,
        updatedEntryIndex: null
      });
    } else {
      // for all other property types we staged a new filter
      const {
        resourceType,
        value
      } = item;
      let customProperty, customPropertyId, dataGroupId, tempDataGroupId, joinPropertyType, propertyDefaultType, propertyObjectKey, type, scdEvent, behavior;
      if (isProperty(item)) {
        ({
          customProperty,
          customPropertyId,
          dataGroupId,
          tempDataGroupId,
          joinPropertyType,
          scdEvent,
          propertyObjectKey,
          propertyDefaultType,
          type,
          behavior
        } = item);
      }
      if (behavior) {
        behavior.dateRange = props.getDefaultDateValue();
        behavior.filters[0].behavior.dateRange = props.getDefaultDateValue();
      }
      // not all custom properties have a well-defined type because the formula could return
      // mixed-typed values. Use 'string' for those cases to hydrate the rest of the filter ui
      const {
        name,
        propertyType
      } = customProperty || {
        name: null,
        propertyType: PropertyType.String
      };
      const propertyName = value || name;
      const propertyFilterAttrs: Partial<PropertyFilter> = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, customProperty ? {
        customProperty
      } : {}), customPropertyId ? {
        customPropertyId
      } : {}), propertyObjectKey ? {
        propertyObjectKey
      } : {}), dataGroupId ? {
        dataGroupId
      } : {}), tempDataGroupId ? {
        tempDataGroupId
      } : {}), {}, {
        resourceType,
        propertyDefaultType: propertyDefaultType || propertyType,
        propertyName,
        propertyType: type || propertyType
      }, joinPropertyType ? {
        joinPropertyType
      } : {}), scdEvent ? {
        scdEvent
      } : {}), isScdPropertyName(propertyName) ? {
        scdOptions: {
          type: "latest",
          // null -> default value means latest as of "now"
          dateRange: null
        }
      } : {}), isAggregationUserFreqByGroupBehavior(behavior) ? {
        behavior,
        filterOperator: NumberOperator.AtLeast,
        filterValue: 1
      } : {});
      const filter = populateListPropertyAttrs(new PropertyFilter(propertyFilterAttrs));
      if (filter.isValid()) {
        handleFilterSectionUpdate(EntryPart.Filters, {
          entries: getFilterEntriesFromFilters([...entryFilters[EntryPart.Filters], filter], props.entry.filtersOperator),
          updatedEntry: null,
          updatedEntryIndex: null
        });
      } else {
        const partialEntry = getFilterEntriesFromFilters([filter], props.entry.filtersOperator)[0];
        props.showPlaceholder(EntryPart.Filters, partialEntry);
      }
    }
  };

  /**
   * Handles filter updates from a nested QueryEntrySection
   */
  const handleFilterSectionUpdate = (source: EntryPart, _ref2: Partial<EntrySectionUpdates<QueryFilterEntry | QueryBehaviorEntry>>) => {
    var _updatedEntry$filters, _entries$, _props$entry;
    let {
      entries,
      updatedEntry,
      updatedEntryIndex,
      queryReason
    }: Partial<EntrySectionUpdates<QueryFilterEntry | QueryBehaviorEntry>> = _ref2;
    const [behavioralFrequencyFilters, filters] = partition(props.entry.filters, filter => filter.customProperty && isBehavioralCustomProperty(filter.customProperty));

    // update the entry's filters operator to match the selected operator from the incoming
    // updated entry, if it's not available fetch it from the first commited filter
    const filtersOperator = (_updatedEntry$filters = updatedEntry === null || updatedEntry === void 0 ? void 0 : updatedEntry.filtersOperator) !== null && _updatedEntry$filters !== void 0 ? _updatedEntry$filters : (_entries$ = entries[0]) === null || _entries$ === void 0 ? void 0 : _entries$.filtersOperator;
    const behavioralFiltersOperator = (updatedEntry as QueryBehaviorEntry === null || updatedEntry as QueryBehaviorEntry === void 0 ? void 0 : (updatedEntry as QueryBehaviorEntry).behavioralFiltersOperator) || ((_props$entry = props.entry) === null || _props$entry === void 0 ? void 0 : _props$entry.behavioralFiltersOperator);
    const updatedFilters = {
      [EntryPart.Filters]: filters,
      // Refold behavioral filters
      [EntryPart.BehavioralFrequencyFilters]: behavioralFrequencyFilters,
      [source]: entries.map((entry, entryIndex): Partial<PropertyFilter> => {
        if (source === EntryPart.BehavioralFrequencyFilters) {
          var _newEntry$property$pr, _newEntry$property, _newEntry$property2, _entryFilter$filterVa;
          const _ref3 = entry as QueryBehaviorEntry,
            {
              type: _,
              entryFilter
            } = _ref3,
            behavior = _objectWithoutProperties(_ref3, _excluded);
          const filterOperator = (entryFilter === null || entryFilter === void 0 ? void 0 : entryFilter.filterOperator) || NumberOperator.AtLeast;
          const newEntry = entryIndex === updatedEntryIndex ? updatedEntry : entry;

          /**
           * @todo [pablo] computing entryFilter type based on math type should be moved
           * one level down (on filters entry section) since this can emit invalid filters
           * forcing validation to be done in a different layer
           */
          const derivedPropertyType = getPropertyTypeForMathType(newEntry.aggregationOperator, (_newEntry$property$pr = (_newEntry$property = newEntry.property) === null || _newEntry$property === void 0 ? void 0 : _newEntry$property.propertyType) !== null && _newEntry$property$pr !== void 0 ? _newEntry$property$pr : (_newEntry$property2 = newEntry.property) === null || _newEntry$property2 === void 0 ? void 0 : _newEntry$property2.type);
          const filterValue = (_entryFilter$filterVa = entryFilter === null || entryFilter === void 0 ? void 0 : entryFilter.filterValue) !== null && _entryFilter$filterVa !== void 0 ? _entryFilter$filterVa : DEFAULT_FILTER_VALUE[derivedPropertyType];
          const filter = new PropertyFilter(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
            // Defaults for behavioral frequency entry
            propertyType: derivedPropertyType,
            propertyDefaultType: derivedPropertyType
          }, entryFilter), {}, {
            resourceType: ResourceType.User,
            // reset properties defined in entryFilter
            propertyName: null,
            dataGroupId: null,
            tempDataGroupId: null,
            customPropertyId: null,
            filterValue,
            // @ts-ignore
            filterOperator
          }, behavior !== null && behavior !== void 0 && behavior.property ? {
            propertyType: derivedPropertyType,
            propertyDefaultType: derivedPropertyType
          } : {}), entryFilter && derivedPropertyType !== entryFilter.propertyType ? {
            propertyType: derivedPropertyType,
            propertyDefaultType: derivedPropertyType,
            filterValue: DEFAULT_FILTER_VALUE[derivedPropertyType],
            filterOperator: derivedPropertyType === PropertyType.Number ? NumberOperator.AtLeast : DEFAULT_FILTER_OPERATOR[derivedPropertyType]
          } : {}), {}, {
            customProperty: {
              name: "",
              description: "",
              behavior: behavior as Behavior
            }
          }));
          !filter.isValid() && props.setActivePart(EntryPart.EntryFilterValue, "open");
          return filter.getAttributes();
        }
        return (entry as QueryFilterEntry).event;
      })
    };
    const entry = _objectSpread(_objectSpread({}, props.entry), {}, {
      filters: [...updatedFilters[EntryPart.Filters], ...updatedFilters[EntryPart.BehavioralFrequencyFilters]]
    }, source !== EntryPart.BehavioralFrequencyFilters ? {
      filtersOperator
    } : {
      filtersOperator: props.entry.filtersOperator || FiltersOperator.And,
      // when removing most behavioral filters, reset the filters operator to `And`
      behavioralFiltersOperator: updatedFilters[EntryPart.BehavioralFrequencyFilters].length === 1 ? FiltersOperator.And : behavioralFiltersOperator
    });

    // when deleting filters and the behavioral operator is `and_any, or_all`, we transition to and/or respectively
    if (behavioralFrequencyFilters.length >= 3 && updatedFilters[EntryPart.BehavioralFrequencyFilters].length < 3 && (props.entry.behavioralFiltersOperator === FiltersOperator.AndAny || props.entry.behavioralFiltersOperator === FiltersOperator.OrAll)) {
      entry.behavioralFiltersOperator = props.entry.behavioralFiltersOperator === FiltersOperator.AndAny ? FiltersOperator.And : FiltersOperator.Or;
    }

    // when deleting all filters, delete the whole group
    const shouldDeleteGroup = entry.filters.length === 0 && props.numStagedRows > 1;
    if (shouldDeleteGroup) {
      props.removeEntry(queryReason);
    } else {
      props.updateEntry(Action.Edit, entry, {
        queryReason
      });
    }
  };
  const isPlaceholder = helpers.isPlaceholder(props);
  const hasFilters = props.entry.filters.length > 0;
  const isStagingFilter = Boolean(props.placeholder);
  const sectionEntries = props.sectionProps.entries as CohortGroupEntry[];
  const hasExtendedOperators = showExtendedLogicalOperators(sectionEntries, "filtersOperator") || showExtendedLogicalOperators(sectionEntries, "behavioralFiltersOperator");
  const filterQueryBlockConfig = {
    elref: "behavioralFilterBlock",
    type: MenuType.Properties,
    theme: ButtonTheme.Tertiary,
    allowTypecastPillAction: TypecastPillAction.TriggerTutorial,
    selectorIcon: "plus",
    hideEditControls: props.sectionProps.hideEditControls,
    dataGroupId: props.sectionProps.dataGroupId,
    enableEnhancedListFilters: props.sectionProps.enableEnhancedListFilters,
    enableWorkspaceFilterRestrictions: props.sectionProps.enableWorkspaceFilterRestrictions,
    excludeCustomEvents: props.sectionProps.excludeCustomEvents,
    inlineCohortsOverride: props.sectionProps.inlineCohortsOverride,
    projectId: props.sectionProps.projectId,
    inputOnly: true,
    showSpecialDatasetProperty: props.sectionProps.showSpecialDatasetProperty,
    trackName: props.sectionProps.trackName,
    selectorType: SelectorType.Button,
    userId: props.sectionProps.userId,
    disabled: props.sectionProps.disabled,
    workspaceId: props.sectionProps.workspaceId,
    showAllTab: true,
    hideEvents: true,
    showAnyEvent: true,
    showSessionEvent: true,
    otherFilterOptions: props.nestedSectionParams.otherFilterOptions,
    // defines what type of properties this dropdown will render
    menuItemTypes: [MenuItemType.Events, MenuItemType.UserProperties, MenuItemType.UserCustomProperties, MenuItemType.LookupTableProperties, MenuItemType.Cohorts, MenuItemType.AggregateUserByGroup],
    allDataGroups: props.sectionProps.dataGroupsEnabled,
    excludeDimensionProperties: props.sectionProps.excludeDimensionProperties,
    includeCustomProperties: props.sectionProps.includeCustomProperties,
    projectHasCohorts: props.sectionProps.projectHasCohorts,
    projectHasPeople: props.sectionProps.projectHasPeople,
    supportB2bCohorts: props.sectionProps.supportB2bCohorts
  };
  const selectorRenderer = () => <>
      <div className='mp-query-entry-selector-title'>{getGroupTitle()}</div>
      {!isStagingFilter && !hasFilters && <QueryBlockReact key='entry-user-filter-selector' {...filterQueryBlockConfig} label={t("query-builder.filter")} autofocus={props.numStagedRows === 1 && props.index === 0} contextPanelParentElement={entryEl} onSelect={handlePropertyItemClick} />}
    </>;
  const bodyRowRenderer = () => {
    var _props$entry$event;
    return <>
      {/** inline user/group/cohort filters */}
      <RowFilters entry={props.entry} eventNames={(_props$entry$event = props.entry.event) !== null && _props$entry$event !== void 0 && _props$entry$event.value ? [props.entry.event.value as string] : []} index={props.index} filters={entryFilters[EntryPart.Filters]}
      /** @todo [pablo] cleanup inline cohorts behavioral rendering */ onUpdate={(_filters, filtersOperator, _queryReason, updates: EntrySectionUpdates<QueryFilterEntry>) => {
        if (filtersOperator && !updates) {
          props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
            filtersOperator
          }));
          return;
        }
        handleFilterSectionUpdate(EntryPart.Filters, updates);
      }} filtersOperators={showExtendedLogicalOperators(sectionEntries, "filtersOperator") && [FiltersOperator.And, FiltersOperator.Or, FiltersOperator.AndAny, FiltersOperator.OrAll]} hideEvents={!isEventBasedEntry(props.entry)} hasNewUI={props.hasNewUI} nestedSectionParams={props.nestedSectionParams} sectionProps={props.sectionProps} placeholders={props.placeholder} onAbortStage={() => props.setActivePart(EntryPart.Filters, "close")} data-sentry-element="RowFilters" data-sentry-source-file="index.tsx" />

      {/* behavioral entry sections */}
      <BehavioralFrequencyFilters {...props} filters={entryFilters[EntryPart.BehavioralFrequencyFilters] || []} handleFilterSectionUpdate={handleFilterSectionUpdate} data-sentry-element="BehavioralFrequencyFilters" data-sentry-source-file="index.tsx" />

      {/** new filter button */}
      {hasFilters && <>
          <div className={clsx("mp-query-entry", "is-add-row", {
          'is-disabled': isPlaceholder
        })}>
            <div className={clsx("entry-selector-prefix", {
            'for-extended-operators': hasExtendedOperators
          })} />
            <QueryBlockReact key='entry-filter-selector' {...filterQueryBlockConfig} label={t("query-builder.filter")} contextPanelParentElement={entryEl} onSelect={handlePropertyItemClick} />
          </div>
        </>}
    </>;
  };

  /** grouping operator control (AND/OR) */
  const groupingControl = props.entry.groupingOperator && <div className={clsx("mp-query-entry-group-operator", "is-".concat(props.entry.groupingOperator))}>
      <ButtonReact elref='entryGroupOperator' theme={props.entry.groupingOperator === FiltersOperator.And ? ButtonTheme.Primary : ButtonTheme.Tertiary} role='button' onClick={handleEntryGroupingOperatorClick} children={print(FiltersOperatorDisplayLabels[props.entry.groupingOperator])} />
    </div>;
  return <>
      <BaseEntryRow ref={setEntryEl} {...props} renderPrefix={null} renderSelector={selectorRenderer} renderBody={bodyRowRenderer} hideActions isPlaceholder={isPlaceholder} overflowControls={props.getCommonOverflowControls()} data-sentry-element="BaseEntryRow" data-sentry-source-file="index.tsx" />
      {groupingControl}
    </>;
}

/**
 * Renders behavioral filters for event based filters, e.g. `Users who did X event Total >= 3 times`
 */
function BehavioralFrequencyFilters(props: EntryRowProps<CohortGroupEntry> & {
  filters: PropertyFilter[];
  handleFilterSectionUpdate;
}) {
  var _props$placeholder, _props$nestedSectionP, _props$entry2;
  const showPlaceholder = (_props$placeholder = props.placeholder) === null || _props$placeholder === void 0 ? void 0 : _props$placeholder.includes(EntryPart.BehavioralFrequencyFilters);
  const updateBehavioralFiltersToThen = (): PropertyFilter[] => {
    // when changing to a funnel behavior, all numeric entryFilters must switch to a
    // `is equal to` numeric frequency filter
    // const behaviorEntry = this.getEntry<QueryBehaviorEntry>(index);
    let [behavioralFrequencyFilters, filters] = partition(props.entry.filters, filter => filter.customProperty && isBehavioralCustomProperty(filter.customProperty));
    behavioralFrequencyFilters = behavioralFrequencyFilters.map(filter => {
      const filterOperator = [NumberOperator.EqualTo, NumberOperator.AtLeast].includes(filter.filterOperator as NumberOperator) ? filter.filterOperator : NumberOperator.EqualTo;
      return applyFilterOperatorToFilter(filterOperator, new PropertyFilter(_objectSpread(_objectSpread({}, filter), {}, {
        propertyType: PropertyType.Number,
        propertyDefaultType: PropertyType.Number,
        customProperty: {
          name: "",
          description: "",
          // resets aggregations to defaults
          behavior: _objectSpread(_objectSpread({}, filter.customProperty.behavior), {}, {
            property: null,
            aggregationOperator: PRIMITIVE_MATH_TYPES.TOTAL
          })
        },
        filterValue: filter.propertyType !== PropertyType.Number ? DEFAULT_FILTER_VALUE.number : filter.filterValue
      }))).getAttributes();
    }) as PropertyFilter[];
    return [...filters, ...behavioralFrequencyFilters];
  };
  const handleBehavioralFilterOperatorChange = (_ref4: {
    operator?: FiltersOperator;
    action?: BehavioralAction;
    entry: QueryBehaviorEntry;
    filterIndex: number;
  }) => {
    let {
      operator,
      action,
      entry,
      filterIndex
    }: {
      operator?: FiltersOperator;
      action?: BehavioralAction;
      entry: QueryBehaviorEntry;
      filterIndex: number;
    } = _ref4;
    const behavioralEntry = _objectSpread(_objectSpread({}, entry), {}, {
      behavioralFiltersOperator: operator !== null && operator !== void 0 ? operator : entry.behavioralFiltersOperator
    });

    // switching to `then` should update all of the behavioral frequency filters
    if (entry.behavioralFiltersOperator !== FiltersOperator.Then && operator === FiltersOperator.Then) {
      props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
        behavioralFiltersOperator: FiltersOperator.Then,
        filters: updateBehavioralFiltersToThen()
      }));
      return;
      // when changing to `who did not, did not, etc...`, we update the frequency filter to `= 0 times`
    } else if (action === BehavioralAction.DidNot) {
      behavioralEntry.property = null;
      behavioralEntry.aggregationOperator = PRIMITIVE_MATH_TYPES.TOTAL;
      behavioralEntry.entryFilter = _objectSpread(_objectSpread({}, DEFAULT_EMPTY_BEHAVIORAL_ENTRY.entryFilter), {}, {
        filterValue: 0,
        filterOperator: NumberOperator.EqualTo
      });
    } else if (action && isBehavioralFilterNegated(entry)) {
      // when changing to `who did, and did, etc...` on a negated entry, `= 0 times`, we revert back to the default state
      behavioralEntry.entryFilter = _objectSpread({}, DEFAULT_EMPTY_BEHAVIORAL_ENTRY.entryFilter);
    }
    const entries = props.filters.map(filter => transformBehavioralFilterToBehavioralEntry(filter));
    props.handleFilterSectionUpdate(EntryPart.BehavioralFrequencyFilters, {
      entries: replaceByIndex(entries, filterIndex, behavioralEntry),
      updatedEntry: behavioralEntry,
      updatedEntryIndex: filterIndex
    });
  };
  const handleAbortStage = () => {
    if (props.entry.filters.length === 0) {
      props.removeEntry();
    }
  };
  if (props.filters.length === 0) {
    return null;
  }
  return <QueryEntrySectionReact key='entryBehavioralFrequencyFiltersSection' className='behavioral-frequency-filters-section' indentFilters elref='entryBehavioralFrequencyFiltersSection' {...props.nestedSectionParams} otherFilterOptions={(_props$nestedSectionP = props.nestedSectionParams.otherFilterOptions) === null || _props$nestedSectionP === void 0 ? void 0 : _props$nestedSectionP.filter(o => o.value !== "$behavior_aggregation")} dataGroupsEnabled={props.sectionProps.dataGroupsEnabled} allowCohortFilter={false} canRenameStep={false} projectHasPeople={props.sectionProps.projectHasPeople} projectHasCohorts={false} disableAddEntry rowLabelType={RowLabelType.None}
  // funnel based behaviors do not allow aggregations as funnel steps, only frequency
  metricsMode={props.entry.behavioralFiltersOperator !== FiltersOperator.Then} includeCustomProperties={IncludeCustomPropertyType.All} hideEditControls={props.sectionProps.hideEditControls} rowTypes={[{
    value: ResourceType.Event,
    includeDateRange: true
  }]} entries={props.filters.map(filter => transformBehavioralFilterToBehavioralEntry(filter, props.entry.behavioralFiltersOperator))} eventAggregatorFunctions={SUPPORTED_BEHAVIORAL_AGGREGATIONS} propertyAggregatorFunctions={SUPPORTED_BEHAVIORAL_AGGREGATIONS} sectionName='inline-cohort' trackProperties={{
    sectionName: "inline-cohort"
  }}
  // renders the AND/OR switch for metric entries (for clarity, the entry type in this renderer function is not a filter type)
  renderPrefix={_ref5 => {
    let {
      index: filterIndex,
      entry
    } = _ref5;
    return <BehavioralRowFiltersPrefix filterIndex={filterIndex} filter={props.filters[filterIndex]} filtersOperator={props.entry.behavioralFiltersOperator} handleChange={(operator, action) => handleBehavioralFilterOperatorChange({
      operator,
      action,
      entry: entry as QueryBehaviorEntry,
      filterIndex
    })} isReadOnlyMode={props.sectionProps.readonly} includeExtendedOperators={showExtendedLogicalOperators(props.sectionProps.entries as CohortGroupEntry[], "behavioralFiltersOperator") && props.filters.length >= 3} isNegated={isBehavioralFilterNegated(entry as QueryBehaviorEntry)} />;
  }} stagingRow={showPlaceholder && _objectSpread(_objectSpread({}, props.placeholder[1]), {}, {
    type: ResourceType.Event,
    behavioralFiltersOperator: ((_props$entry2 = props.entry) === null || _props$entry2 === void 0 ? void 0 : _props$entry2.behavioralFiltersOperator) || FiltersOperator.And
  }) as QueryEntry} onUpdate={(updates: EntrySectionUpdates<QueryBehaviorEntry>) => props.handleFilterSectionUpdate(EntryPart.BehavioralFrequencyFilters, updates)} onAbortStage={handleAbortStage} data-sentry-element="QueryEntrySectionReact" data-sentry-component="BehavioralFrequencyFilters" data-sentry-source-file="index.tsx" />;
}

/**
 * For behaviors using extended logical operators (and any, or all), we display a different UI
 * where these options are displayed in cascading menu, for every other case we display a flat list
 */
function BehavioralRowFiltersPrefix(props: {
  filtersOperator: FiltersOperator;
  filter: PropertyFilter;
  filterIndex: number;
  handleChange: (operator: FiltersOperator, action: BehavioralAction) => void;
  isReadOnlyMode: boolean;
  includeExtendedOperators: boolean;
  isNegated: boolean;
}) {
  const {
    t
  } = useTranslation();
  return <>
      {RowFiltersPrefix({
      filtersOperator: props.filtersOperator,
      filter: props.filter,
      filterIndex: props.filterIndex,
      handleChange: (item: SectionItem<FiltersOperator>) => props.handleChange(item.value, null),
      isReadOnlyMode: props.isReadOnlyMode,
      forBehaviors: true,
      filtersOperators: props.includeExtendedOperators ? [FiltersOperator.And, FiltersOperator.Or, FiltersOperator.AndAny, FiltersOperator.OrAll, FiltersOperator.Then] : [FiltersOperator.And, FiltersOperator.Or, FiltersOperator.Then]
    })}
      <SelectReact className='entry-selector-behavioral-action' elref='behavioralFilterActionSelect' theme={SelectTheme.Select} menuWidth={100} sections={[{
      items: [{
        value: BehavioralAction.Did,
        label: t("filters.user-operator.did"),
        isSelected: !props.isNegated
      }, {
        value: BehavioralAction.DidNot,
        label: t("filters.user-operator.did-not"),
        isSelected: props.isNegated
      }]
    }]} neverShowCaret onChange={(ev: ChangeEvent) => props.handleChange(null, ev.detail.item.value as BehavioralAction)} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx" />
    </>;
}